/* eslint-disable local-rules/too-complex-useeffects */
import {useEffect} from 'react';
import {CheckoutExperiment} from '../hooks/useCheckoutEntryDetails';
// eslint-disable-next-line monorepo/no-internal-import
import {useCOTracking} from '@aboutyou/tracking/src/utils/coTracking';
import {getIsBnplOffered} from '../hooks/getIsBnplOffered';

export const ReportPaymentLoadTiming: React.FC<{
  experiments: CheckoutExperiment[];
}> = ({experiments}) => {
  const {track} = useCOTracking();

  const isBnplOffered = getIsBnplOffered(experiments);

  useEffect(() => {
    const handlePaymentLoadTiming = (event: Event) => {
      const item = (event as CustomEvent<CheckoutPaymentLoadTimingEvent>)
        .detail;
      const {value, includes_shipping} = item;

      track({
        type: 'PaymentLoadTiming',
        duration: value,
        includes_shipping,
        zbnpl_offered: isBnplOffered, // keep for backward compatibility, will be removed in the future
        is_bnpl_offered: isBnplOffered,
      });
    };

    window.addEventListener(PAYMENT_LOAD_TIMING, handlePaymentLoadTiming);

    return () => {
      window.removeEventListener(PAYMENT_LOAD_TIMING, handlePaymentLoadTiming);
    };
  }, [track, isBnplOffered]);

  return null;
};

type CheckoutPaymentLoadTimingEvent = {
  type: 'PaymentLoadTiming';
  value: number;
  includes_shipping: boolean;
};

const PAYMENT_LOAD_TIMING = 'PaymentLoadTiming';

export const dispatchCheckoutPaymentLoadTimingEvent = (
  event: CheckoutPaymentLoadTimingEvent,
) => {
  window.dispatchEvent(new CustomEvent(PAYMENT_LOAD_TIMING, {detail: event}));
};
